<template>
  <section class="">
    <div class="row">
      <div class="box-body form-left p-l-10 p-r-10-p">
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              店家名稱(ID)
            </span>
            <div class="form-control form-info">
              {{storeInfo.name}} ({{storeInfo.id}})
            </div>
          </div>
          <br />
        </div>
      </div>
      <div class="box-body form-right p-l-10 p-r-10-p">
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              電話
            </span>
            <div class="form-control form-info">
              {{storeInfo.tel}}
            </div>
          </div>
          <br />
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 table-responsive p-x-0">
        <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable">
          <thead>
          <tr role="row">
            <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">時間</th>
            <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">連線ID</th>
            <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">連線狀態</th>
          </tr>
          </thead>
          <tbody>
          <tr class="even td-status" role="row" v-for="(mqtt, index) in mqttList" :status="mqtt.status">
            <td>
              {{getTime(mqtt.create_time)}}
            </td>
            <td>{{mqtt.client_id}}</td>
            <td>
              <span v-if="mqtt.status === 1" class="label label-success">建立</span>
              <span v-if="mqtt.status === 2"  class="label label-danger">中斷</span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<script>
import $ from 'jquery'
// Require needed datatables modules
import moment from 'moment'

export default {
  props: ['isSearch', 'date', 'statusSelect'],
  name: 'Tables',
  data () {
    return {
      name: '迷客夏',
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      total: 1,
      count: 20,
      history: false,
      storeList: [],
      mqttList: [],
      storeInfo: {
        id: '',
        name: '',
        tel: ''
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      $('#example1').DataTable({
        'paging': false,
        'ordering': false,
        'pagingType': 'numbers',
        'info': false,
        'lengthChange': false,
        'filter': false
      })
    })
  },
  methods: {
    getMqttTable () {
      var self = this
      let date = moment(this.date).format('YYYYMMDD')
      var url = 'store/' + this.$route.params.store_id + '/mqttHistory/?date=' + date
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          if (response.data.history.mqtt_info) self.mqttList = response.data.history.mqtt_info
          else self.mqttList = []
          self.storeInfo = {
            id: response.data.history.id,
            name: response.data.history.name,
            tel: response.data.history.tel
          }
        }
      })
      this.isSearch.active = false
    },
    getTime (time) {
      return moment(time, 'YYYY-MM-DD HH:mm:ss').format('HH:mm:ss')
    }
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    }
  },
  watch: {
    'isSearch.active' () {
      if (this.isSearch.active) {
        this.getMqttTable()
      }
    },
    statusSelect () {
      let select = parseInt(this.statusSelect, 10)
      $('.td-status').each(function () {
        let sId = parseInt($(this).attr('status'), 10)
        if (select === 99) {
          $(this).show()
        } else {
          if (select === sId) $(this).show()
          else $(this).hide()
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// MqttSearchTemp.vue?698a0f3d